import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Select } from 'components/Shared/Forms';
import { BREAKPOINTS, SCAFFOLDING } from 'theme';
import { useRecoilValue } from 'recoil';
import { languagesSelector } from 'modules/languages';

const StyledSelect = styled(Select)`
    min-width: 15em;

    @media (min-width: ${`${BREAKPOINTS.xxl}px`}) {
        width: calc(50% - ${SCAFFOLDING.GUTTER_FACTOR(0.25)});
    }
`;

export const LanguagesSelect = ({ name = 'language' }) => {
    const languages = useRecoilValue(languagesSelector);
    const selectOptions = useMemo(() => languages.map(({ code, name }) => ({ label: name, value: code })), [languages]);
    return <StyledSelect name={name} options={selectOptions} searchable />;
};
